<form [formGroup]="form" (ngSubmit)="save()" class="reject">
   <div class="jbm-modal-header">
      <div class="jbm-crud-title">
         <div class="title">{{'entity.invoice'|translate}} {{'ui.cancel'|translate|lowercase}}</div>
      </div>
      <div class="toolbar float-end">
         <jbm-help-button [class]="'light'" [helpTopicID]="0"></jbm-help-button>
         <div class="toolbar-spacer-1"></div>
         <jbm-cross-close-button (onClick)="close()"></jbm-cross-close-button>
      </div>
   </div>
   <div class="jbm-modal-body">
      <jbm-static-label [labelCaption]="'invoice.number'|translate" [value]="invoiceNumber"></jbm-static-label>
      <jbm-textarea [id]="'comments'" [formControl]="formControls.comments" labelStacked="true" class="xl"
        [labelCaption]="'entity.comments'|translate"></jbm-textarea>
   </div>
   <div class="jbm-modal-footer">
      <div class="toolbar float-end">
         <button type="button" class="btn btn-sm btn-success" (click)="save()">{{'entity.invoice'|translate}} {{'ui.cancel'|translate|lowercase}}</button>
         <div class="toolbar-spacer-1"></div>
         <jbm-cancel-button (click)="close()"></jbm-cancel-button>
      </div>
   </div>
</form>